import React, { useState,useEffect } from 'react';
import { Accordion, Form, Button, Modal } from 'react-bootstrap';
import api from '../../seller-apis/api';
import Header from '../common/Header';
import './termscondition.css'
import { useAlert } from 'react-alert';

const Termsconditions = () => {
  const alert = useAlert()
  const [ischecked, setisChecked] = useState(false);
  const [termsCond, settermsCond] = useState([]);
  const [acceptBtnstat, setacceptBtnstat] = useState({ "backgroundColor": "#339a99", "opacity": "0.5" })
  const [otpSent, setotpSent] = useState(false);
  const [first, setfirst] = useState();
  const [second, setsecond] = useState();
  const [third, setthird] = useState();
  const [fourth, setfourth] = useState();
  const [modalShow, setmodalShow] = useState(false);

  
  useEffect(()=>{
    api.seller.vterms().then(res=>{
      console.log(res)
      settermsCond(res.data)
    }).catch(err=>console.log(err))
},[])

  function formcheckEvt() {
    let ele = document.getElementById("t_cond_checkBox");
    if (ele.checked) {
      setisChecked(true)
      setacceptBtnstat({ "backgroundColor": "#339a99", "opacity": "1" })
    }
    else {
      setisChecked(false)
      setacceptBtnstat({ "backgroundColor": "#339a99", "opacity": "0.5" })
    }
  }


  // Send otp

  function sendOtp() {
    if (ischecked) {
      let data = {
        "phoneNumber": localStorage.getItem("phone")
      }
      api.auth.login(data).then((res) => {
        console.log(res)
        if (res.message === "Otp Sent ") {
          setotpSent(true)
          alert.show('Otp sent', {
            type: 'success'
          })
          setmodalShow(true)
        }
        else {
          setmodalShow(false)
          alert.show('Otp not sent', {
            type: 'error'
          })
        }
      })

    }
  }

  // Input otp

  function inputotp(e, no) {
    console.log(e)
    let btns = document.getElementsByClassName("form-control-val");

    if (e.keyCode === 8) {
      if (no > 0) {
        console.log("dnjk")
        btns[no].value = ""
        btns[no].disabled = false;
        btns[no - 1].disabled = false
        btns[no - 1].focus();

      }
      else {
        btns[no].disabled = false;
        btns[no].value = ""
        btns[no].focus()
      }
    }
    else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
      console.log(typeof (btns[no].value))
      if (no < 3) {
        btns[no + 1].disabled = false;
        btns[no].disabled = true
        btns[no + 1].focus()
      }
      else {
        //  btns[no].disabled = true;
        btns[no].focus()
        btns[no].select()
      }
    }
  }

  function handleInput(e, num) {
    if (isNaN(e)) {
      if (num === 0) {
        setfirst(first)
      }
      else if (num === 1) {
        setsecond(second)
      }
      else if (num === 2) {
        setthird(third)
      }
      else if (num === 3) {
        setfourth(fourth)
      }
    }
    else {
      if (e > 9) {
        if (num === 0) {
          setfirst(first)
        }
        else if (num === 1) {
          setsecond(second)
        }
        else if (num === 2) {
          setthird(third)
        }
        else if (num === 3) {
          setfourth(fourth)
        }
      }
      else {
        if (num === 0) {
          setfirst(e)
        }
        else if (num === 1) {
          setsecond(e)
        }
        else if (num === 2) {
          setthird(e)
        }
        else if (num === 3) {
          setfourth(e)
        }
      }
    }

  }


  // Modal related

  const handleClose = () => {
    setmodalShow(false)
    setfirst()
    setsecond()
    setthird()
    setfourth()
  }

  // Otp verification

  const verifyOtp = () => {
    let otp = first + second + third + fourth
    console.log(otp)
    let data = {
      "phoneNumber": localStorage.getItem("phone"),
      "otp": otp
    }
    api.auth.verifyOtp(data)
      .then((res) => {
        console.log(res)
        if (res.message === "Enter Correct OTP") {
          // setotpstatus("block")
          alert.show("Please enter correct Otp", {
            type: 'error'
          })
        } else {
          alert.show("Verification done", {
            type: 'success'
          })
        }
      })
      .catch(err => console.log(err))
  }


  return (
    <>
      <div className="oM-c" id="outer">
        <Header />
        <div>
          <Accordion defaultActiveKey="0">
          {termsCond.length>0 ? termsCond.map((item,index)=>{
              return(
                <Accordion.Item eventKey={index} key={item._id}>
                <Accordion.Header>{item.title}</Accordion.Header>
                <Accordion.Body dangerouslySetInnerHTML={{__html: item.desc}}>
                 
                </Accordion.Body>
              </Accordion.Item>
              )
            }):<></>}
          
          </Accordion>
        </div>
      </div>
      <div className='t_cond-accept-cntn'>
        <Form className="m-3">
          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Check id="t_cond_checkBox" onChange={() => formcheckEvt()} type="checkbox" label="I have read carefully all the terms and conditions, and I hereby provide my consent for same." />
          </Form.Group>
          <div className="m-auto t_cond-accept-btn" style={acceptBtnstat}>
            {ischecked ? <p className="p-1 cursor" onClick={() => sendOtp()}>Accept</p> : <p className="p-1">Accept</p>}
          </div>

        </Form>



      </div>
      {otpSent ? <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className='mb-2'>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <h5 class="m-0">Mobile phone verification</h5>
              <span class="mobile-text-tc">Please enter the code we just sent on your mobile phone
                <b class="text-danger"> {localStorage.getItem("phone")}</b></span>

            </Form.Group>

            <div class="d-flex flex-row mt-2">
              <input type="text" className="form-control form-control-val" value={first} autofocus="" onChange={(e) => handleInput(e.target.value, 0)} onKeyUp={(e) => inputotp(e, 0)} />
              <input type="text" className="form-control form-control-val" value={second} disabled onChange={(e) => handleInput(e.target.value, 1)} onKeyUp={(e) => inputotp(e, 1)} />
              <input type="text" className="form-control form-control-val" value={third} disabled onChange={(e) => handleInput(e.target.value, 2)} onKeyUp={(e) => inputotp(e, 2)} />
              <input type="text" className="form-control form-control-val" value={fourth} onChange={(e) => handleInput(e.target.value, 3)} disabled onKeyUp={(e) => inputotp(e, 3)} />
            </div>
            <div class="text-center mt-3">
              <Button variant='secondary' className='mb-3 bg-theme' size='sm' onClick={() => verifyOtp()}>Verify</Button>
              <span class="d-block mobile-text-tc">Didn't receive the code <i class="fa fa-question" aria-hidden="true"></i></span>
              <span class="font-weight-bold text-danger cursor" onClick={() => sendOtp()}>Resend</span>

            </div>
          </Form>
        </Modal.Body>
      </Modal> : <></>}

    </>
  )
}

export default Termsconditions;